// Waagerechtes Gitter und y-Beschriftung. In der Ratenansicht sind das
// Prozentwerte, in der Änderungsansicht die Bin-Zeilen.

import { PALETTE } from "../../palette";
import { deltaLabel, pct } from "../../format";
import type { G, Model } from "../model";

export function drawGrid(g: G, model: Model, lang: string): void {
    const { marginLeft, innerW } = model.layout;
    const right = marginLeft + innerW;

    if (model.isRate) {
        g.selectAll("line")
            .data(model.yTicks)
            .join("line")
            .attr("x1", marginLeft)
            .attr("x2", right)
            .attr("y1", (v) => model.yRate(v))
            .attr("y2", (v) => model.yRate(v))
            .attr("stroke", PALETTE.grid);

        g.selectAll("text")
            .data(model.yTicks)
            .join("text")
            .attr("x", marginLeft - 8)
            .attr("y", (v) => model.yRate(v) + 4)
            .attr("text-anchor", "end")
            .attr("font-size", 11)
            .attr("fill", PALETTE.inkMuted)
            .text((v) => pct(v, lang, 2));
        return;
    }

    g.selectAll("line")
        .data(model.deltas)
        .join("line")
        .attr("x1", marginLeft)
        .attr("x2", right)
        .attr("y1", (v) => model.yDelta(v) + model.rowH / 2)
        .attr("y2", (v) => model.yDelta(v) + model.rowH / 2)
        .attr("stroke", PALETTE.grid);

    g.selectAll("text")
        .data(model.deltas)
        .join("text")
        .attr("x", marginLeft - 8)
        .attr("y", (v) => model.yDelta(v) + 4)
        .attr("text-anchor", "end")
        .attr("font-size", 11)
        .attr("fill", PALETTE.inkMuted)
        .text((v) => deltaLabel(v, lang));
}
